<template>
  <v-container fluid pa-0 class="paymentHistory">
    <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">Reports</v-flex>
    <v-card v-if="subscription" class="elevation-0" secondary style="padding: 60px; flex: none; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700; text-align: left" class="primary--text">Subscription Billing</div>
      <v-data-table style="margin-top: 60px" :headers="headers" :items="invoiceLines" :pagination.sync="pagination" hide-actions>
        <template slot="items" slot-scope="props" v-if="props.item.plan.id.indexOf('SUBSCRIPTION') !== -1" style="font-size: 18px;">
          <td>{{ getProjectNameByUuid(props.item.plan.id) }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.planName }}</td>
          <!-- <td>{{ invoiceDates(props.item.period.start) }}</td> -->
          <!-- <td>{{ invoiceDates(props.item.period.end) }}</td> -->
          <td>${{ parseFloat(props.item.amount/100).toFixed(2) }}</td>
        </template>
      </v-data-table>
    </v-card>

    <v-card v-if="diy" class="elevation-0" secondary style="padding: 60px; flex: none; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700; text-align: left" class="primary--text">DIY Billing</div>
      <v-data-table style="margin-top: 60px" :headers="headers" :items="invoiceLines" :pagination.sync="pagination" hide-actions>
        <template slot="items" slot-scope="props" v-if="props.item.plan.id.indexOf('DIY') !== -1">
          <td>{{ getProjectNameByUuid(props.item.plan.id) }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.planName }}</td>
          <!-- <td>{{ invoiceDates(props.item.period.start) }}</td> -->
          <!-- <td>{{ invoiceDates(props.item.period.end) }}</td> -->
          <td>${{ parseFloat(props.item.amount/100).toFixed(2) }}</td>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="elevation-0" secondary style="padding: 60px; flex: none; margin-top: 60px">
      <v-flex v-if="!(warning || success)" class="loadingState"><v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular></v-flex>
      <v-layout row :class="!(warning || success) ? 'blurClass' : ''">
        <div xs12 style="font-size: 24px; font-weight: 700; text-align: left" class="primary--text">Total Payments</div>
        <v-flex v-if="warning || success" style="text-align:right;">
          <span style="font-size: 24px; font-weight: 700">{{ total }}</span>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card v-if="upcomingInvoice.length > 0" class="elevation-0" secondary style="padding: 60px; flex: none; margin-top: 60px">
      <div xs12 style="font-size: 24px; font-weight: 700; text-align: left" class="primary--text">Upcoming Invoice</div>
      <v-data-table style="margin-top: 60px" :headers="headersUpcoming" :items="upcomingInvoice" :pagination.sync="pagination" hide-actions>
        <template slot="items" slot-scope="props">
          <td>{{ getProjectNameByUuid(props.item.plan.id) }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.planName }}</td>
          <!-- <td>{{ invoiceDates(props.item.period.start) }}</td> -->
          <!-- <td>{{ invoiceDates(props.item.period.end) }}</td> -->
          <td>${{ parseFloat(props.item.amount/100).toFixed(2) }}</td>
          <td>{{ invoiceDates(props.item.nextPaymentAttempt) }}</td>
        </template>
      </v-data-table>
      <v-layout row v-if="warning || success" style="text-align:right; margin-top: 30px">
        <span class="primary--text" style="font-size: 24px; font-weight: 700">Total</span>
        <v-spacer></v-spacer>
        <span class="primary--text" style="font-size: 24px; font-weight: 500">{{ totalUpcoming }}</span>
      </v-layout>
    </v-card>

  </v-container>
</template>

<style>
.blurClass{
  -webkit-filter: blur(5px);
  filter: blur(5px);
}
.loadingState, .noDataState, .errorState{
    background-color: rgba(255, 255, 255, 0.1);
    display: flex;
    position: absolute;
    top: 0;
    width: 100%;
    bottom: 0;
    align-items: center;
    justify-content: center;
  }
.noDataState {
  box-shadow: none !important;
}
.StripeElement {
   background-color: rgba(0,0,0,.06);
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.paymentHistory th{
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #011E41 !important;
  height: 70px;
}
.paymentHistory th i{
  font-size: 18px !important;
  padding-left: 10px !important
}
.paymentHistory .v-datatable__progress{
  display: none !important;
}
.paymentHistory thead tr{
  border: none !important;
}
.paymentHistory tbody tr{
  background-color: #EBEFFF !important;
  border-bottom: 10px solid white !important;
  border-top: 10px solid white !important;
  min-height: 70px !important
}
.paymentHistory tbody tr td{
  font-size: 18px !important;
  height: 70px;
}
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>

<script>
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      headers: [
        { text: 'Project', value: 'projectName' },
        { text: 'Description', value: 'description' },
        { text: 'Tier', value: 'planName' },
        // { text: 'From', value: 'period.start' },
        // { text: 'Until', value: 'period.end' },
        { text: 'Price', value: 'amount' }
      ],
      headersUpcoming: [
        { text: 'Project', value: 'projectName' },
        { text: 'Description', value: 'description' },
        { text: 'Tier', value: 'planName' },
        // { text: 'From', value: 'period.start' },
        // { text: 'Until', value: 'period.end' },
        { text: 'Price', value: 'amount' },
        { text: 'Next Payment', value: 'nextPaymentAttempt' }
      ],
      customerId: null,
      defaultId: null,
      updating: false,
      loading: false,
      complete: false,
      warning: false,
      success: false,
      invoices: null,
      upcomingInvoice: [],
      invoiceLines: [],
      projects: [],
      pagination: {
        rowsPerPage: -1
      },
      plans: [],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getPlanByUuid: 'getPlanByUuid'
    }),
    diy: function () {
      return this.invoices ? this.invoices.filter(x => { return x.lines.data[0].plan.id.indexOf('DIY') !== -1 }).length > 0 : false
    },
    subscription: function () {
      return this.invoices ? this.invoices.filter(x => { return x.lines.data[0].plan.id.indexOf('SUBSCRIPTION') !== -1 }).length > 0 : false
    },
    total: function () {
      return this.invoices ? this.invoices.map(function (x) { return parseFloat(x.total / 100) }).reduce((a, b) => a + b, 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : parseFloat(0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    },
    totalUpcoming: function () {
      return this.upcomingInvoice ? this.upcomingInvoice.map(function (x) { return parseFloat(x.amount / 100) }).reduce((a, b) => a + b, 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : parseFloat(0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    invoiceDates: function (period) {
      return this.months[new Date(Number(period) * 1000).getMonth()] + ' ' + new Date(Number(period) * 1000).getDate() + ', ' + new Date(Number(period) * 1000).getFullYear()
    },
    getProjectNameByUuid: function (uuid) {
      uuid = uuid.split('_prod_')[1].split('_plan')[0]
      let project = this.projects.find(x => { return x.uuid === uuid })
      return project ? project.name : null
    },
    getPlanNameByUuid: function (uuid) {
      uuid = uuid.split('_plan_')[1]
      let plan = this.getPlanByUuid(uuid)
      return plan ? plan.displayName : null
    },
    getData () {
      let organizationUuid = this.getUserOrganization.uuid
      let stripeSubIds = []
      if (this.getUserOrganization.stripeSubConfig !== null) {
        for (let stripeId in this.getUserOrganization.stripeSubConfig) {
          if (stripeId !== 'billing_cycle_anchor') {
            stripeSubIds.push(this.getUserOrganization.stripeSubConfig[stripeId])
          }
        }
      }
      axios.all([this.$store.dispatch('stripe/retrieveCustomer', {organizationUuid: organizationUuid}), this.$store.dispatch('stripe/listAllInvoicesByCustomerId', {organizationUuid: organizationUuid}), this.$store.dispatch('stripe/getUpcomingInvoiceByCustomerId', {organizationUuid: organizationUuid, stripeSubIds: stripeSubIds})]).then(axios.spread((customerResponse, invoicesResponse, upcomingInvoiceResponse) => {
        if (customerResponse.data.status === 'SUCCESS' && invoicesResponse.data.status === 'SUCCESS' && upcomingInvoiceResponse !== undefined) {
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.id !== undefined) {
            this.customerId = customerResponse.data.payload.id
          }
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.sources !== null && customerResponse.data.payload.sources.totalCount !== 0) {
            this.cards = customerResponse.data.payload.sources.data
            this.deletingCard = null
            this.defaultId = customerResponse.data.payload.defaultSource ? customerResponse.data.payload.defaultSource.id : null
            this.warning = false
            this.success = true
          } else {
            this.cards = null
            this.warning = true
            this.success = false
          }
          if (upcomingInvoiceResponse.length > 0) {
            for (let i = 0; i < upcomingInvoiceResponse.length; i++) {
              if (upcomingInvoiceResponse[i].data.payload) {
                for (let j = 0; j < upcomingInvoiceResponse[i].data.payload.lines.data.length; j++) {
                  axios.all([this.$store.dispatch('stripe/getProjectByUuid', {uuid: upcomingInvoiceResponse[i].data.payload.lines.data[j].plan.id.split('_prod_')[1].split('_plan')[0]})]).then(axios.spread((projectByUuidResponse) => {
                    if (projectByUuidResponse.data.status === 'SUCCESS') {
                      this.projects.push(projectByUuidResponse.data.payload)
                      upcomingInvoiceResponse[i].data.payload.lines.data[j].projectName = projectByUuidResponse.data.payload.name
                    }
                  })).catch((err) => {
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                }
                for (let j = 0; j < upcomingInvoiceResponse[i].data.payload.lines.data.length; j++) {
                  upcomingInvoiceResponse[i].data.payload.lines.data[j].planName = this.getPlanNameByUuid(upcomingInvoiceResponse[i].data.payload.lines.data[j].plan.id)
                  upcomingInvoiceResponse[i].data.payload.lines.data[j].nextPaymentAttempt = upcomingInvoiceResponse[i].data.payload.nextPaymentAttempt
                }
                this.upcomingInvoice.push(...upcomingInvoiceResponse[i].data.payload.lines.data)
              }
            }
          }
          if (invoicesResponse.data.payload) {
            for (let i = 0; i < invoicesResponse.data.payload.length; i++) {
              for (let j = 0; j < invoicesResponse.data.payload[i].lines.data.length; j++) {
                axios.all([this.$store.dispatch('stripe/getProjectByUuid', {uuid: invoicesResponse.data.payload[i].lines.data[j].plan.id.split('_prod_')[1].split('_plan')[0]})]).then(axios.spread((projectByUuidResponse) => {
                  if (projectByUuidResponse.data.status === 'SUCCESS') {
                    this.projects.push(projectByUuidResponse.data.payload)
                    invoicesResponse.data.payload[i].lines.data[j].projectName = projectByUuidResponse.data.payload.name
                  }
                })).catch((err) => {
                  this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                  console.log(err)
                })
              }
            }
            this.invoices = invoicesResponse.data.payload
            for (let i = 0; i < invoicesResponse.data.payload.length; i++) {
              for (let j = 0; j < invoicesResponse.data.payload[i].lines.data.length; j++) {
                invoicesResponse.data.payload[i].lines.data[j].planName = this.getPlanNameByUuid(invoicesResponse.data.payload[i].lines.data[j].plan.id)
              }
              this.invoiceLines.push(...invoicesResponse.data.payload[i].lines.data)
            }
          }
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted: function () {
    this.customerId = null
    this.defaultId = null
    this.cards = null
    this.deletingCard = null
    this.setCardAsDefault = null
    this.updating = false
    this.loading = false
    this.complete = false
    this.warning = false
    this.success = false
    this.invoices = null
    this.upcomingInvoice = []
    this.invoiceLines = []
    this.projects = []
    this.plans = []
    this.getData()
  },
  watch: {
    getUserOrganization: function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.customerId = null
        this.defaultId = null
        this.cards = null
        this.deletingCard = null
        this.setCardAsDefault = null
        this.updating = false
        this.loading = false
        this.complete = false
        this.warning = false
        this.success = false
        this.invoices = null
        this.upcomingInvoice = []
        this.invoiceLines = []
        this.projects = []
        this.plans = []
        this.getData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationPaymentHistory.vue